module.exports = __webpack_public_path__ + "static/media/archive-book.d68d1bde.svg";